export function timeToDecimalHours(hours, minutes) {
    return parseFloat(parseInt(hours, 10) + parseInt(minutes, 10) / 60).toFixed(
        2
    );
}

export const getTotal = (name, object) => {    
    if (!object || !name) return;
    const keys = Object.keys(object);
    const total =
        keys
            .map((row) => parseFloat(object?.[row]?.[name] ?? 0) ?? 0)
            ?.reduce((a, b) => a + b, 0) ?? 0;
    return total;
};